import { createRoute } from '@signal/router';
import { ACCOUNT } from './core';
export var INDUSTRY_REPORTS = createRoute(ACCOUNT, 'industryReports');
export var INDUSTRY_REPORT = createRoute(INDUSTRY_REPORTS, ':reportSlug');
export var INDUSTRY_SUB_REPORT = createRoute(INDUSTRY_REPORT, ':subReportSlug');